import React from "react";
import { Space, Collapse } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import Contact from "./Contact";
import { useIntl } from "react-intl";
const { Panel } = Collapse;

const Contacts = (props) => {
  const { contacts } = props;
  const intl = useIntl();
  const mainContact =
    contacts && contacts.filter((i) => i.main_contact === true)[0];
  return (
    <div className="component">
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
        className="custom-collapse-section contacts"
      >
        <Panel
          header={intl.formatMessage({
            id: "app.sidebar.contacts",
          })}
          key={"1"}
        >
          <Space direction="vertical" size="small" style={{ width: "100%" }}>
            {contacts &&
              contacts.map((r) => (
                <Contact
                  key={r.id}
                  record={r}
                  defaultKey={mainContact && mainContact.id}
                />
              ))}
          </Space>
        </Panel>
      </Collapse>
    </div>
  );
};
export default Contacts;
